module.exports = __webpack_public_path__ + "img/040_thumbnail.2b7450f1.jpg";